import { render, staticRenderFns } from "./CarouselItemDesktop.vue?vue&type=template&id=fec5cdf4&scoped=true&"
import script from "./CarouselItemDesktop.vue?vue&type=script&lang=js&"
export * from "./CarouselItemDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CarouselItemDesktop.vue?vue&type=style&index=0&id=fec5cdf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec5cdf4",
  null
  
)

export default component.exports